export default __webpack_public_path__ + "static/media/downIcon.fc431947.svg";